import uniqId from 'lodash/uniqueId';

import BaseModel from '../base';

export default class TournamentStageGroup extends BaseModel {
  constructor(group, url) {
    super(group, url);

    this.id = group.id || uniqId();
    this.name = group.name || '';
    this.description = group.description || '';

    this.tournament_stage_id = group.tournament_stage_id;
  }
}
